<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import LabelledInput from "../components/Form/LabelledInput.svelte";
	import Button from "../components/Button.svelte";
	import forgotPassword from "../appsync/mutations/forgotPassword.graphql";
	import { getClients } from "../appsync/getClients.js";
	import { createPromiseStore } from "../../../core/utils/createPromiseStore.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Form from "../components/Form/Form.svelte";
	import Message from "../components/Message.svelte";
	import { expectErrorMessage } from "../components/Form/expectErrorMessage.js";
	import preloader from "../../../core/assets/icons/preloader.svg?raw";
	import Icon from "../components/Icon.svelte";
	import { confirmForgotPasswordPathMap } from "../../../core/schema/paths/confirmForgotPasswordPathMap";

	const globalSettings = getGlobalSettings();
	const { TENANT_ID, TENANT_LOCALE } = globalSettings;

	const forgot = createPromiseStore(async (email: string) => {
		const { graphQL } = await getClients(globalSettings);
		return graphQL.mutate({
			mutation: forgotPassword,
			variables: {
				email,
				tenantId: TENANT_ID,
			},
		});
	});

	$: forgotPasswordErrorMessage =
		$forgot.status === "error" &&
		expectErrorMessage(
			$forgot.error,
			TENANT_LOCALE,
			{},
			"Chyba při žádosti o obnovu hesla. Zkuste to prosím znovu nebo později.",
		);

	async function submitConfirm(event: SubmitEvent): Promise<void> {
		if ($forgot.status === "loading") {
			return;
		}
		const form = event.target as HTMLFormElement;
		const formData = new FormData(form);
		const email = String(formData.get("email"));
		await forgot.call(email);
		const redirectTimeout = setTimeout(() => {
			if ($forgot.status === "success") {
				window.location.assign(`/${confirmForgotPasswordPathMap[TENANT_LOCALE]}?email=${encodeURIComponent(email)}`);
			}
			clearTimeout(redirectTimeout);
		}, 5000);
		form.reset();
	}
</script>

<Layout>
	<div class="container flex max-w-[32rem] flex-col gap-8">
		<div class="flex flex-col">
			<h2>{nbspify("Obnova hesla")}</h2>

			<Form on:submit={submitConfirm} class="flex flex-col gap-2">
				<LabelledInput id="email" type="email" required>E-mail</LabelledInput>

				<div class="mx-auto">
					{#if $forgot.status === "loading"}
						<Icon icon={preloader} class="aspect-auto h-10 w-12" />
					{:else}
						<Button type="submit" class="mx-auto">Obnovit heslo</Button>
					{/if}
				</div>
			</Form>
		</div>

		{#if $forgot.status === "success"}
			<Message variant="success"
				>{nbspify(
					"Na váš e-mail byl odeslán odkaz pro obnovu hesla. Budete přesměrováni na další krok, kde jej můžete zadat.",
				)}</Message
			>
		{:else if forgotPasswordErrorMessage}
			<Message variant="error">
				{forgotPasswordErrorMessage}
			</Message>
		{/if}
	</div>
</Layout>
